<app-navbar></app-navbar>
<div class="container">

    <h1>
        Movie Review by <span class="text-blue-800"> {{this.author}}</span> 
    </h1>

    <p>{{this.content}}</p> 
 
</div>
<app-footer></app-footer>
